import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { TextInput } from '../text-input'
import { IconButton, Link } from '@mui/material'
import { LinkIcon } from 'src/assets/icons'
import { getPolygonscanAddressUrl } from 'src/common/utils'
import { useTranslation } from 'react-i18next'
import { useStyles } from './styles'
import { ETranslationNs } from 'src/types'
import { useCopy } from 'src/hooks'
import { useAppAddressAndBalance } from 'src/hooks'

export const AddressAndBalanceHolder = () => {
  const addressAndBalance = useAppAddressAndBalance()
  const address = addressAndBalance.data?.address ?? ''
  const balance = `${Number(addressAndBalance.data?.balance).toFixed(5) ?? ''} ETH`
  const [t] = useTranslation(ETranslationNs.Form)
  const classes = useStyles()
  const handleCopy = useCopy(address)
  return (
    <div className={classes.holder}>
      <TextInput
        fullWidth={false}
        inputPlaceholder=""
        disabled
        inputUpperLabel={t('wallet-address-input-label.v')}
        value={address}
        fontSize={11}
        endIcon={
          <div className={classes.iconsWrapper}>
            <IconButton
              disabled={!address}
              size="small"
              component={Link}
              href={address ? getPolygonscanAddressUrl(address) : '#'}
              target="_blank"
            >
              <LinkIcon className={classes.copyIcon} />
            </IconButton>

            <IconButton size="small" disabled={!address} onClick={handleCopy}>
              <ContentCopyIcon className={classes.copyIcon} />
            </IconButton>
          </div>
        }
      />
      <TextInput
        fullWidth={false}
        inputPlaceholder=""
        disabled
        inputUpperLabel={t('wallet-balance-input-label.v')}
        value={balance}
        fontSize={20}
      />
    </div>
  )
}
